import { useCallback, useState } from 'react'
import { m, LazyMotion, domAnimation, useAnimation } from 'framer-motion'

import { CardAdornmentSm } from '../../../../../assets/icons'
import CardContent from '../content'

import styles from './index.module.scss'

// Animations
const CARD_ADORNMENTS_ANIMATION = {
  start: { y: '30%', opacity: 0 },
  end: {
    y: '0%',
    opacity: 1,
    transition: { type: 'spring', bounce: 0, duration: 0.6 },
  },
}

const CARD_1_ANIMATION_LARGE = {
  start: {
    y: '-75%',
    x: '-50%',
    opacity: 0,
  },
  middle: {
    y: 101,
    x: '-50%',
    opacity: 1,
    transition: { type: 'spring', bounce: 0, duration: 0.6 },
  },
  third: {
    width: '300px',
    y: 86,
    x: '-50%',
    opacity: 0.6,
    transition: { type: 'spring', bounce: 0, duration: 0.4, delay: 1 },
  },
  end: {
    width: '290px',
    y: 71,
    x: '-50%',
    opacity: 0.3,
    transition: { type: 'spring', bounce: 0, duration: 0.4, delay: 1 },
  },
}

const CARD_2_ANIMATION_LARGE = {
  start: { y: '-75%', x: '-50%', opacity: 0 },
  middle: {
    y: 101,
    x: '-50%',
    opacity: 1,
    transition: { type: 'spring', bounce: 0, duration: 0.6, delay: 1 },
  },
  end: {
    width: '300px',
    y: 86,
    x: '-50%',
    opacity: 0.6,
    transition: { type: 'spring', bounce: 0, duration: 0.4, delay: 1 },
  },
}

const CARD_3_ANIMATION_LARGE = {
  start: { y: '-75%', x: '-50%', opacity: 0 },
  end: {
    y: 101,
    x: '-50%',
    opacity: 1,
    transition: { type: 'spring', bounce: 0, duration: 0.6, delay: 1 },
  },
}

const SmallCards = () => {
  const [wasAnimationTriggered, setWasAnimationTriggered] = useState(false)

  const cardsAdornments = useAnimation()
  const cards1Control = useAnimation()
  const cards2Control = useAnimation()
  const cards3Control = useAnimation()

  const onViewportEnter = useCallback(() => {
    if (wasAnimationTriggered) {
      return
    }
    setWasAnimationTriggered(true)

    cardsAdornments.start('end')
    cards1Control.start('middle').then(() => {
      cards2Control.start('middle').then(() => {
        cards3Control.start('end')
        cards2Control.start('end')
        cards1Control.start('end')
      })
      cards1Control.start('third')
    })
  }, [wasAnimationTriggered, cardsAdornments, cards1Control, cards2Control, cards3Control])

  const animations = [
    {
      animate: cards1Control,
      variants: CARD_1_ANIMATION_LARGE,
      initial: 'start',
    },
    {
      animate: cards2Control,
      variants: CARD_2_ANIMATION_LARGE,
      initial: 'start',
    },
    {
      animate: cards3Control,
      variants: CARD_3_ANIMATION_LARGE,
      initial: 'start',
    },
  ]

  return (
    <LazyMotion features={domAnimation} strict>
      <m.div
        className={styles['cards-wrapper']}
        viewport={{ once: true, amount: 0.7 }}
        initial="start"
        onViewportEnter={onViewportEnter}
      >
        <m.div
          className={styles['adornments-wrapper']}
          variants={CARD_ADORNMENTS_ANIMATION}
          initial="start"
          animate={cardsAdornments}
        >
          <CardAdornmentSm className={styles['adornment']} />
        </m.div>
        <CardContent animate={animations} />
      </m.div>
    </LazyMotion>
  )
}

export default SmallCards
